import React, { useMemo, useState } from 'react';
import axios from 'axios';
import {
	Box,
	Button,
	Checkbox,
	Divider,
	Flex,
	FormControl,
	FormLabel,
	Heading,
	HStack,
	Input,
	Select,
	Spacer,
} from '@chakra-ui/react';
import { options } from './data';

export const Ticket = ({
	ticket: {
		id,
		title,
		content,
		reporter,
		customer,
		customer_id,
		history,
		assignee_id,
		assignee,
		created_at,
		due_date,
		closed,
	},
	workers,
	admin,
	setWakeTickets,
	setUserID,
	withTitle = true,
}) => {
	const workersList = workers.reduce(
		(acc, { id, name }) => ({ ...acc, [id]: name }),
		{}
	);
	const events = JSON.parse(history);

	const statusAction = closed ? 'Reopen ticket' : 'Close ticket';
	const [newDueDate, setNewDueDate] = useState(due_date.slice(0, 10));
	const [newStatus, setNewStatus] = useState(closed);
	const [newAssignee, setNewAssignee] = useState(assignee_id);
	const [comment, setComment] = useState('');

	const isUpdateDisabled = useMemo(() => {
		if (newDueDate !== due_date) return false;
		if (newStatus !== closed) return false;
		if (newAssignee !== assignee_id) return false;
		if (comment !== '') return false;

		return true;
	}, [
		newStatus,
		closed,
		newAssignee,
		assignee_id,
		comment,
		newDueDate,
		due_date,
	]);

	const handleUpdate = () => {
		let data = { id, admin };
		if (newDueDate !== due_date) data = { ...data, dueDate: newDueDate };
		if (newStatus !== closed) data = { ...data, closed: newStatus };
		if (newAssignee !== assignee_id) data = { ...data, assignee: newAssignee };
		if (comment !== '') data = { ...data, comment };

		axios({
			method: 'put',
			url: `/tickets`,
			data,
			...options(),
		})
			.then(() => {
				setComment('');
				setWakeTickets(new Date().getTime());
			})
			.catch(console.log);
	};

	return (
		<Box>
			{withTitle ? (
				<Heading pb={6} fontSize={'lg'}>
					{`№${id} «${title}»`}
				</Heading>
			) : (
				customer_id > 0 && (
					<Box
						pb={4}
						color="Teal"
						cursor="pointer"
						onClick={async () => {
							await setUserID(-1);
							await setUserID(customer_id);
						}}
					>
						Customer: {customer}
					</Box>
				)
			)}
			<Flex pb={4} alignItems="center">
				<Box>
					By: <b>{reporter}</b>
				</Box>
				<Spacer />
				<Box>
					{' '}
					<Input
						type="date"
						value={newDueDate}
						onChange={e => setNewDueDate(e.target.value)}
					/>
				</Box>
				<Spacer />
				<HStack>
					<Box>To:</Box>
					<Select
						placeholder="Choose an assignee"
						onChange={e => setNewAssignee(Number.parseInt(e.target.value))}
						value={newAssignee}
					>
						{workers.map(({ id, name }) => (
							<option value={id}>{name}</option>
						))}
					</Select>
				</HStack>
			</Flex>
			<Divider mb={4} />
			<Box pb={4}>{content}</Box>
			<Divider mb={4} />
			<Box>
				{events.map(({ comment, reassign, updateDueDate }) => {
					if (comment)
						return (
							<Box pb={4}>
								<Box>
									{`${comment.date} `}
									<b>{workersList[comment.author]}</b>
								</Box>
								<Box>{comment.comment}</Box>
							</Box>
						);
					if (updateDueDate)
						return (
							<Box pb={4}>
								<Box>
									{`${updateDueDate.date} `}
									<b>{workersList[updateDueDate.author]}</b>
									&nbsp;updated due date:&nbsp;
									<b>{updateDueDate.dueDate}</b>
								</Box>
							</Box>
						);
					return (
						<Box pb={4}>
							{`${reassign.date} `}
							<b>{workersList[reassign.author]}</b>
							&nbsp;reassigned to&nbsp;
							<b>{workersList[reassign.assignee]}</b>
						</Box>
					);
				})}
			</Box>
			<Divider mb={4} />
			<FormControl mb={4}>
				<FormLabel>Comment</FormLabel>
				<Input
					type="text"
					placeholder="Enter the comment text here"
					value={comment}
					onChange={e => setComment(e.target.value)}
				/>
			</FormControl>
			<Flex pb={4} alignItems="center">
				<Checkbox
					colorScheme="blue"
					checked={newStatus}
					onChange={e => {
						setNewStatus(!newStatus);
					}}
				>
					{statusAction}
				</Checkbox>
				<Spacer />
				<Button
					colorScheme="blue"
					isDisabled={isUpdateDisabled}
					onClick={handleUpdate}
				>
					Update
				</Button>
			</Flex>
		</Box>
	);
};
